import React from "react";
import { useTranslation } from "react-i18next";
import { Instagram, Facebook, Youtube, Twitter } from "lucide-react";

const SOCIALS = [
  {
    name: "Instagram",
    url: "https://instagram.com/tasting-horizons",
    Icon: Instagram,
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61584005612392",
    Icon: Facebook,
  },
  {
    name: "YouTube",
    url: "https://youtube.com/@tasting-horizons",
    Icon: Youtube,
  },
];

function FollowUsSection({
  title,
  subtitle,
  socials = SOCIALS,
  gradient = "from-teal to-sage",
}) {
  const { t } = useTranslation();
  const computedTitle =
    title ?? t("follow.title", { defaultValue: "Follow Our Journey" });
  const computedSubtitle =
    subtitle ??
    t("follow.subtitle", {
      defaultValue:
        "Stay connected with us for the latest stories, videos, and updates.",
    });

  return (
    <section className={`py-16 bg-gradient-to-r ${gradient}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h2 className="text-3xl font-bold mb-3">{computedTitle}</h2>
        <p className="text-lg mb-8 text-white/90">{computedSubtitle}</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {socials.map(({ name, url, Icon }) => (
            <a
              key={name}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center gap-2 rounded-lg border border-white/20 bg-white/10 px-4 py-3 hover:bg-white/15 hover:border-white/30 transition-colors"
            >
              <Icon className="h-5 w-5 text-white" />
              <span className="font-medium">{name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FollowUsSection;
